import Store from '../store'
import Vue from "vue"
// import moment from "moment"
// import {defaultDescription, defaultImage, defaultTitle, defaultUrl} from "@/store/Constants";


// For emit any event through vue page
export const eventBus = new Vue()


// Header for use get on frontend
export const corsHeader = { headers: { 'Access-Control-Allow-Origin': '*' } }


// About date / time
export const getCurrentDate = new Date().toISOString().split('T')[0]

// export function getDatesBetween (startDate, endDate) {
//     let dates = []
//     let currDate = moment(startDate).startOf('day')
//     let lastDate = moment(endDate).startOf('day')
//
//     while (currDate.add(1, 'days').diff(lastDate) < 0) {
//         dates.push(currDate.clone().toDate())
//     }
//     let resultArray = [
//         moment(startDate).toDate(),
//         ...dates,
//         moment(endDate).toDate()
//     ]
//     return resultArray
// }

export function validateContainerNo (container_number) {
    let regEx = /[A-Z]{3}[UJZ][0-9]{7}/
    return regEx.test(container_number)
}

export function validateEmail (email) {
    let regEx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    return regEx.test(email)
}

export function formatNumber (x, toFixed = 0) {
    if (!x && x != 0) {
        return 0
    }
    if (toFixed === 0) {
        return parseFloat(x).toFixed(toFixed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else if (toFixed !== 0) {
        return parseFloat(x)
            .toFixed(toFixed)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
}

export function formatPhoneText (phone, uncen = true) {
    if (!phone) return phone
    phone = phone.toString()
    if (uncen) return phone.substr(0,3) + ' ' + phone.substr(3,3) + ' ' + phone.substr(6,4)
    return phone.substr(0,3) + ' ' + phone.substr(3,3) + ' xxxx'
}

export function textToInt (x) {
    if (!x || typeof x == 'number') return x
    if (typeof x == 'string') {
        return parseFloat(x.replace(/,/g, ""))
    }
    return parseFloat(x.toString().replace(/,/g, ""))
}


export function genString (length = 10) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let result = ' '
    const charactersLength = characters.length
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
}


export function dataIsCorrect (x) {
    return x !== null && x !== undefined && x !== ''
}


// split text and remove by 'number' or 'string'
export function splitRemove (remove = 'number', char) {
    if (remove === 'number') {
        return char.match(/[a-zA-Z]+/g)
    } else {
        return char.match(/\d+/g)
    }
}

// jwt decode
export function parseJwt (token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
}


export function findWithAttr (array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i
        }
    }
    return -1
}


export function toSlugId (title, id) {
    // check '/' and ' ' letters replace with '-'
    title = title.toString().replace(/[/ ?&#]/g, '-')
    return title + '-' + id
}

export function toQuoteContent (content) {
    content = content.toString().replace(/["'“”`’]/g, '')
    return content
}


export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getMobileOperatingSystem() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone"
    }

    if (/android/i.test(userAgent)) {
        return "Android"
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS"
    }

    return "unknown"
}


// export function setMetaTags (d, w = null, title = defaultTitle, description = defaultDescription, image = defaultImage) {
//
//     let currentUrl = defaultUrl
//     if (w) currentUrl = decodeURIComponent(w.location.href)
//
//     // avoid content contain some letters like ' " `
//     title = toQuoteContent(title)
//     description = toQuoteContent(description)
//
//     // title
//     d.title = title + ' - Nainaar'
//
//     // canonical
//     if (d.querySelector("link[rel='canonical']")) {
//         d.querySelector("link[rel='canonical']").setAttribute('href', currentUrl)
//     } else {
//         let canonical = d.createElement('link')
//         canonical.rel = 'canonical'
//         canonical.href = currentUrl
//         d.getElementsByTagName('title')[0].after(canonical)
//     }
//
//     // description
//     if (d.querySelector("meta[name='description']")) {
//         d.querySelector("meta[name='description']").setAttribute('content', description)
//     } else {
//         let descriptionTag = d.createElement('meta')
//         descriptionTag.name = 'description'
//         descriptionTag.content = description
//         d.getElementsByTagName('title')[0].after(descriptionTag)
//     }
//
//     // og:image
//     if (d.querySelector("meta[property='og:image']")) {
//         d.querySelector("meta[property='og:image']").setAttribute('content', image)
//     } else {
//         let ogimage = d.createElement('meta')
//         ogimage.property = 'og:image'
//         ogimage.content = image
//         d.getElementsByTagName('title')[0].after(ogimage)
//     }
//
//     // og:title
//     if (d.querySelector("meta[property='og:title']")) {
//         d.querySelector("meta[property='og:title']").setAttribute('content', title)
//     } else {
//         let ogtitle = d.createElement('meta')
//         ogtitle.property = 'og:title'
//         ogtitle.content = title
//         d.getElementsByTagName('title')[0].after(ogtitle)
//     }
//
//     // og:description
//     if (d.querySelector("meta[property='og:description']")) {
//         d.querySelector("meta[property='og:description']").setAttribute('content', description)
//     } else {
//         let ogdesc = d.createElement('meta')
//         ogdesc.property = 'og:description'
//         ogdesc.content = description
//         d.getElementsByTagName('title')[0].after(ogdesc)
//     }
//
//     // og:url
//     if (d.querySelector("meta[property='og:url']")) {
//         d.querySelector("meta[property='og:url']").setAttribute('content', currentUrl)
//     } else {
//         let ogurl = d.createElement('meta')
//         ogurl.property = 'og:url'
//         ogurl.content = currentUrl
//         d.getElementsByTagName('title')[0].after(ogurl)
//     }
//
// }
export function detectBrowser__c (userAgent) {
  userAgent = userAgent.toLowerCase()
  switch (true) {
    case userAgent.indexOf("edge") > -1: return "MS Edge"
    case userAgent.indexOf("edg/") > -1: return "Edge (chromium based)"
    case userAgent.indexOf("opr") > -1 && !!window.opr: return "Opera"
    case (userAgent.indexOf("chrome") > -1 && !!window.chrome) || userAgent.indexOf("crios") > -1: return "Chrome"
    case userAgent.indexOf("trident") > -1: return "IE"
    case userAgent.indexOf("firefox") > -1 || userAgent.indexOf("fxios") > -1: return "Mozilla Firefox"
    case userAgent.indexOf("safari") > -1: return "Safari"
    default: return "other"
  }
}

export function getMapLinkByCoord (lat, lng) {
    let link = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
    return link
}


export function isImgExists (image_url) {
    let http = new XMLHttpRequest()
    http.open('HEAD', image_url, false)
    http.send()
    return http.status != 404
}


export function htmlDecode(input) {
    let doc = new DOMParser().parseFromString(input, "text/html")
    return doc.documentElement.textContent
}


export function parentRoute (currentRouteName) {
    let x = currentRouteName.toString().split('/')
    switch (x[2]) {
        case 'Order':
        case 'NewOrder':
        case 'DraftOrder':
        case 'QuotationDetail':
        case 'DeliveryOrderDetail':
            return 'Order'

        case 'Payment':
        case 'PaymentForm':
            return 'Payment'

        case 'Request':
        case 'NewRequest':
        case 'DraftRequest':
            return 'Request'

        case 'Complaint':
        case 'NewComplaint':
        case 'DraftComplaint':
            return 'Complaint'

        case 'Article':
        case 'ArticleCategory':
        case 'ArticleDetail':
            return 'Article'

        case 'Report':
            return 'Report'

        default:
            return undefined
    }
}

export function resizeImage(img, extension = 'png') {

    let canvas = document.createElement('canvas')

    let width = img.width
    let height = img.height
    let max_width = 500
    let max_height = 500

    // calculate the width and height, constraining the proportions
    if (width > height) {
        if (width > max_width) {
            //height *= max_width / width;
            height = Math.round(height *= max_width / width)
            width = max_width
        }
    } else {
        if (height > max_height) {
            //width *= max_height / height;
            width = Math.round(width *= max_height / height)
            height = max_height
        }
    }

    // resize the canvas and draw the image data into it
    canvas.width = width
    canvas.height = height
    let ctx = canvas.getContext("2d")
    ctx.drawImage(img, 0, 0, width, height)

    //preview.appendChild(canvas) // do the actual resized preview
    return canvas.toDataURL("image/"+extension, 0.7) // get the data from canvas as 70% JPG (can be also PNG, etc.)

}


export function entityParse(content) {
    if (content) {
        let decoded = document.createElement("textarea")
        decoded.innerHTML = content
        return decoded.value
    }
    return ""
}